import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputSwitch } from 'primereact/inputswitch';
import { MultiSelect } from 'primereact/multiselect';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import UserInfo from '../../../shared/UserInfo/UserInfo';
import Messages from '../../../shared/UI/Messages/Messages';
import { DROPDOWN_CONFIG, CALENDAR_CONFIG } from '../../../shared/Config';
import { removeString, DateFormetter, REDIRECT_TO_URL, DECRYPT } from '../../../shared/utility';
import axios from '../../../axios-url';
import * as actions from '../../../store/actions/index';
import moment from 'moment';

// ─── Field type constants (unchanged) ───────────────────────────────────────
const INPUT = 1;
const DROPDOWN_TYPE = 2;
const MULTIDROPDOWN = 3;
const CHECKBOX = 4;
const RADIO = 5;
const TEXTAREA = 6;
const DATETIMEPICKER = 7;
const DATEPICKER = 8;
const CONTAINER = 9;
const SWITCH = 10;
const FILE = 11;

// ─── Process constant (unchanged) ───────────────────────────────────────────
const TABLE_RESERVATION_PROCESS_ID = 'b1f0b0ec-df1d-414b-bd09-9aed7f0ba1bb';

// ─── Table options (unchanged) ───────────────────────────────────────────────
const TABLE_OPTIONS = [
    { label: 'Table 1 (2 seats)', value: 'T1', cap: 2, icon: 'pi-table', private: false },
    { label: 'Table 2 (4 seats)', value: 'T2', cap: 4, icon: 'pi-table', private: false },
    { label: 'Table 3 (4 seats)', value: 'T3', cap: 4, icon: 'pi-table', private: false },
    { label: 'Table 4 (6 seats)', value: 'T4', cap: 6, icon: 'pi-table', private: false },
    { label: 'Table 5 (8 seats)', value: 'T5', cap: 8, icon: 'pi-table', private: false },
    { label: 'Table 6 (Private)', value: 'T6', cap: 12, icon: 'pi-lock', private: true },
];

// Time slots for the time-picker strip
const TIME_SLOTS = [
    '12:00 PM', '12:30 PM', '1:00 PM', '1:30 PM', '2:00 PM', '2:30 PM',
    '7:00 PM', '7:30 PM', '8:00 PM', '8:30 PM', '9:00 PM',
];

// ─── Styles ──────────────────────────────────────────────────────────────────
const STYLES = `
  :root {
    --res-burgundy:    #6B1E2E;
    --res-burgundy-dk: #4E1520;
    --res-burgundy-lt: #8C2A3E;
    --res-gold:        #C9A84C;
    --res-gold-lt:     #E8D49E;
    --res-ivory:       #FAF7F2;
    --res-ivory-dk:    #F0EBE0;
    --res-text:        #2C1A10;
    --res-text-muted:  #7A6350;
    --res-border:      #DDD0BC;
    --res-white:       #FFFFFF;
    --res-shadow:      0 2px 12px rgba(107,30,46,0.08);
    --res-radius:      10px;
    --res-radius-sm:   6px;
  }

  /* Page */
  .res-page { background: var(--res-ivory); min-height: 100vh; padding-bottom: 2rem; }

  /* Header banner */
  .res-header-banner {
    background: linear-gradient(135deg, var(--res-burgundy-dk) 0%, var(--res-burgundy) 60%, var(--res-burgundy-lt) 100%);
    padding: 1.5rem 2rem;
    display: flex; align-items: center; justify-content: space-between;
    border-bottom: 3px solid var(--res-gold);
    margin-bottom: 1.5rem;
  }
  .res-header-title {
    color: var(--res-white); font-size: 1.55rem; font-weight: 700;
    letter-spacing: 0.04em; margin: 0; display: flex; align-items: center; gap: 0.6rem;
  }
  .res-header-subtitle {
    color: var(--res-gold-lt); font-size: 0.8rem; margin: 0.2rem 0 0;
    letter-spacing: 0.1em; text-transform: uppercase;
  }

  /* Step bar */
  .res-step-bar {
    display: flex; border-radius: var(--res-radius); overflow: hidden;
    border: 1px solid var(--res-border); margin-bottom: 1.5rem;
    box-shadow: var(--res-shadow);
  }
  .res-step {
    flex: 1; padding: 0.6rem 0.5rem; text-align: center;
    font-size: 0.75rem; font-weight: 700; letter-spacing: 0.05em;
    text-transform: uppercase; background: var(--res-ivory-dk);
    color: var(--res-text-muted); border-right: 1px solid var(--res-border);
    cursor: pointer; transition: background 0.15s;
  }
  .res-step:last-child { border-right: none; }
  .res-step.active { background: var(--res-burgundy); color: var(--res-white); }
  .res-step.done   { background: var(--res-gold-lt);  color: var(--res-burgundy-dk); }
  .res-step-num {
    display: inline-flex; align-items: center; justify-content: center;
    width: 18px; height: 18px; border-radius: 50%;
    background: rgba(255,255,255,0.2); font-size: 0.7rem; margin-right: 5px;
  }

  /* Panels */
  .res-panel { display: none; }
  .res-panel.active { display: block; }

  /* Cards */
  .res-card {
    background: var(--res-white); border: 1px solid var(--res-border);
    border-radius: var(--res-radius); box-shadow: var(--res-shadow);
    margin-bottom: 1.25rem; overflow: hidden;
  }
  .res-card-header {
    background: linear-gradient(90deg, var(--res-ivory-dk), var(--res-ivory));
    border-bottom: 2px solid var(--res-gold);
    padding: 0.75rem 1.5rem; display: flex; align-items: center; gap: 0.5rem;
  }
  .res-card-header h2 {
    margin: 0; font-size: 0.95rem; font-weight: 700;
    color: var(--res-burgundy); text-transform: uppercase; letter-spacing: 0.03em;
  }
  .res-card-header .res-card-icon { color: var(--res-gold); font-size: 1.1rem; }
  .res-card-body { padding: 1.25rem 1.5rem; }

  /* Section heading */
  .res-section-head {
    font-size: 0.78rem; font-weight: 700; color: var(--res-burgundy);
    text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 0.75rem;
    display: flex; align-items: center; gap: 0.4rem;
  }

  /* ── Calendar ── */
  .res-cal-header {
    display: flex; align-items: center; justify-content: space-between; margin-bottom: 0.75rem;
  }
  .res-cal-month { font-size: 1rem; font-weight: 700; color: var(--res-text); }
  .res-cal-nav {
    background: var(--res-ivory-dk); border: 1px solid var(--res-border);
    border-radius: var(--res-radius-sm); width: 30px; height: 30px;
    cursor: pointer; display: flex; align-items: center; justify-content: center;
    color: var(--res-text-muted);
  }
  .res-cal-nav:hover { background: var(--res-border); }
  .res-cal-grid { display: grid; grid-template-columns: repeat(7,1fr); gap: 3px; }
  .res-cal-dayname {
    text-align: center; font-size: 0.72rem; color: var(--res-text-muted);
    padding: 4px 0; font-weight: 700;
  }
  .res-cal-day {
    aspect-ratio: 1; display: flex; align-items: center; justify-content: center;
    border-radius: var(--res-radius-sm); font-size: 0.82rem; cursor: pointer;
    color: var(--res-text); position: relative; transition: background 0.1s;
    user-select: none;
  }
  .res-cal-day:hover:not(.unavail):not(.empty) { background: var(--res-ivory-dk); }
  .res-cal-day.today { font-weight: 700; color: var(--res-burgundy); }
  .res-cal-day.selected {
    background: var(--res-burgundy) !important;
    color: var(--res-white) !important;
    font-weight: 700;
  }
  .res-cal-day.unavail { color: var(--res-border); cursor: default; text-decoration: line-through; }
  .res-cal-day.empty   { cursor: default; }
  .res-cal-day.has-dot::after {
    content: ''; position: absolute; bottom: 3px; left: 50%; transform: translateX(-50%);
    width: 4px; height: 4px; border-radius: 50%; background: var(--res-gold);
  }
  .res-cal-day.selected::after { background: rgba(255,255,255,0.6); }

  /* ── Time slots ── */
  .res-time-grid {
    display: grid; grid-template-columns: repeat(auto-fill, minmax(90px,1fr)); gap: 8px;
    margin-top: 0.5rem;
  }
  .res-time-slot {
    border: 1.5px solid var(--res-border); border-radius: var(--res-radius-sm);
    padding: 0.4rem 0.4rem; text-align: center; font-size: 0.8rem;
    cursor: pointer; color: var(--res-text); background: var(--res-ivory);
    transition: all 0.1s;
  }
  .res-time-slot:hover:not(.slot-full) { border-color: var(--res-burgundy); color: var(--res-burgundy); }
  .res-time-slot.selected {
    background: var(--res-burgundy); border-color: var(--res-burgundy);
    color: var(--res-white); font-weight: 700;
  }
  .res-time-slot.slot-full { color: var(--res-border); cursor: default; font-style: italic; }
  .res-slot-sub { display: block; font-size: 0.65rem; margin-top: 1px; opacity: 0.75; }

  /* ── Table tiles ── */
  .res-table-grid {
    display: grid; grid-template-columns: repeat(auto-fill, minmax(130px,1fr)); gap: 10px;
  }
  .res-table-tile {
    border: 1.5px solid var(--res-border); border-radius: var(--res-radius);
    padding: 0.85rem 0.75rem; cursor: pointer; background: var(--res-ivory);
    text-align: center; position: relative; transition: all 0.15s; user-select: none;
  }
  .res-table-tile:hover:not(.tile-taken) { border-color: var(--res-burgundy); }
  .res-table-tile.selected {
    border: 2px solid var(--res-burgundy); background: rgba(107,30,46,0.06);
  }
  .res-table-tile.tile-taken { opacity: 0.4; cursor: not-allowed; }
  .res-tile-icon { font-size: 1.5rem; margin-bottom: 0.35rem; display: block; color: var(--res-burgundy); }
  .res-tile-name { font-size: 0.82rem; font-weight: 700; color: var(--res-text); }
  .res-tile-cap  { font-size: 0.7rem; color: var(--res-text-muted); margin-top: 2px; }
  .res-tile-tag  {
    display: inline-block; font-size: 0.65rem; padding: 2px 8px;
    border-radius: 20px; margin-top: 6px; font-weight: 700;
  }
  .tag-avail   { background: #d4edda; color: #155724; }
  .tag-taken   { background: #f8d7da; color: #721c24; }
  .tag-private { background: #e2d9f3; color: #4a2c7a; }
  .res-tile-check {
    position: absolute; top: 6px; right: 6px; font-size: 0.75rem;
    color: var(--res-burgundy); display: none;
  }
  .res-table-tile.selected .res-tile-check { display: block; }

  /* ── Stepper ── */
  .res-guest-rows {
    border: 1px solid var(--res-border); border-radius: var(--res-radius);
    overflow: hidden; background: var(--res-ivory);
  }
  .res-guest-row {
    display: flex; align-items: center; justify-content: space-between;
    padding: 0.65rem 1rem; border-bottom: 1px solid var(--res-border);
  }
  .res-guest-row:last-child { border-bottom: none; }
  .res-guest-label  { font-size: 0.85rem; font-weight: 700; color: var(--res-text); }
  .res-guest-sub    { font-size: 0.7rem; color: var(--res-text-muted); }
  .res-stepper {
    display: flex; align-items: center;
    border: 1px solid var(--res-border); border-radius: var(--res-radius-sm); overflow: hidden;
  }
  .res-step-btn {
    width: 32px; height: 32px; border: none; cursor: pointer;
    background: var(--res-ivory-dk); color: var(--res-text-muted);
    font-size: 1.1rem; display: flex; align-items: center; justify-content: center;
  }
  .res-step-btn:hover { background: var(--res-border); }
  .res-step-val {
    width: 38px; text-align: center; font-size: 0.9rem; font-weight: 700;
    color: var(--res-text); background: var(--res-white);
    height: 32px; line-height: 32px;
  }

  /* Tag toggles */
  .res-tag-toggles { display: flex; gap: 0.5rem; flex-wrap: wrap; margin-top: 0.75rem; }
  .res-tag-toggle {
    border: 1.5px solid var(--res-border); border-radius: 20px;
    padding: 0.3rem 0.85rem; font-size: 0.75rem; font-weight: 700;
    cursor: pointer; color: var(--res-text-muted); background: var(--res-ivory);
    transition: all 0.1s; user-select: none;
  }
  .res-tag-toggle.on {
    border-color: var(--res-burgundy); background: rgba(107,30,46,0.07);
    color: var(--res-burgundy);
  }

  /* Total bar */
  .res-total-bar {
    background: var(--res-ivory-dk); border: 1px solid var(--res-border);
    border-radius: var(--res-radius-sm); padding: 0.65rem 1rem;
    display: flex; align-items: center; justify-content: space-between; margin-top: 0.75rem;
  }
  .res-total-lbl { font-size: 0.72rem; color: var(--res-text-muted); font-weight: 700; text-transform: uppercase; }
  .res-total-num { font-size: 1.3rem; font-weight: 700; color: var(--res-text); }

  /* Field */
  .res-field { margin-bottom: 1rem; }
  .res-label {
    display: block; font-size: 0.75rem; font-weight: 700;
    color: var(--res-burgundy); letter-spacing: 0.06em; text-transform: uppercase;
    margin-bottom: 0.4rem;
  }
  .res-required { color: #c0392b; margin-left: 2px; }

  /* PrimeReact overrides */
  .res-page .p-inputtext,
  .res-page .p-dropdown,
  .res-page .p-multiselect,
  .res-page .p-calendar .p-inputtext {
    border: 1.5px solid var(--res-border); border-radius: var(--res-radius-sm);
    background: var(--res-ivory); color: var(--res-text);
    font-size: 0.88rem; width: 100%;
  }
  .res-page .p-inputtextarea {
    border: 1.5px solid var(--res-border); border-radius: var(--res-radius-sm);
    background: var(--res-ivory); color: var(--res-text);
    font-size: 0.88rem; width: 100%; resize: vertical;
  }
  .res-page .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider { background: var(--res-burgundy); }

  /* Summary sidebar */
  .res-summary-card {
    background: var(--res-white); border: 1px solid var(--res-border);
    border-radius: var(--res-radius); overflow: hidden;
    box-shadow: var(--res-shadow);
  }
  .res-summary-header {
    background: var(--res-burgundy); padding: 0.65rem 1rem;
    color: var(--res-white); font-size: 0.72rem; font-weight: 700;
    letter-spacing: 0.08em; text-transform: uppercase;
  }
  .res-summary-body { padding: 0.75rem 1rem; }
  .res-sum-row {
    display: flex; justify-content: space-between; align-items: flex-start;
    padding: 0.3rem 0; border-bottom: 1px solid var(--res-ivory-dk);
    font-size: 0.8rem;
  }
  .res-sum-row:last-child { border-bottom: none; }
  .res-sum-lbl { color: var(--res-text-muted); }
  .res-sum-val { font-weight: 700; color: var(--res-text); text-align: right; max-width: 55%; word-break: break-word; }

  /* Chip */
  .res-chip {
    display: inline-flex; align-items: center; gap: 0.3rem;
    background: rgba(107,30,46,0.09); color: var(--res-burgundy);
    border: 1px solid rgba(107,30,46,0.2); border-radius: 20px;
    padding: 0.2rem 0.65rem; font-size: 0.75rem; font-weight: 700;
  }

  /* Action bar */
  .res-action-bar {
    background: var(--res-ivory-dk); border-top: 2px solid var(--res-gold);
    padding: 0.9rem 1.5rem; display: flex; align-items: center;
    gap: 0.75rem; flex-wrap: wrap;
    border-radius: 0 0 var(--res-radius) var(--res-radius);
  }
  .res-ml-auto { margin-left: auto; }

  /* Buttons */
  .res-btn-primary {
    background: var(--res-burgundy) !important; border-color: var(--res-burgundy) !important;
    color: var(--res-white) !important; font-weight: 700;
    border-radius: var(--res-radius-sm) !important; padding: 0.5rem 1.2rem !important;
  }
  .res-btn-primary:hover:not(:disabled) { background: var(--res-burgundy-dk) !important; }
  .res-btn-secondary {
    background: var(--res-ivory-dk) !important; border-color: var(--res-border) !important;
    color: var(--res-burgundy) !important; font-weight: 700;
    border-radius: var(--res-radius-sm) !important; padding: 0.5rem 1.1rem !important;
  }
  .res-btn-gold {
    background: var(--res-gold) !important; border-color: var(--res-gold) !important;
    color: var(--res-burgundy-dk) !important; font-weight: 700;
    border-radius: var(--res-radius-sm) !important; padding: 0.5rem 1.1rem !important;
  }
  .res-btn-danger {
    background: #c0392b !important; border-color: #c0392b !important;
    color: var(--res-white) !important; font-weight: 700;
    border-radius: var(--res-radius-sm) !important; padding: 0.5rem 1.1rem !important;
  }
  .res-btn-warning {
    background: #e67e22 !important; border-color: #e67e22 !important;
    color: var(--res-white) !important; font-weight: 700;
    border-radius: var(--res-radius-sm) !important; padding: 0.5rem 1.1rem !important;
  }

  /* readonly */
  .res-readonly-card { opacity: 0.8; pointer-events: none; }
  .res-readonly-badge {
    display: inline-flex; align-items: center; gap: 0.3rem;
    font-size: 0.68rem; background: var(--res-gold-lt); color: var(--res-burgundy);
    border: 1px solid var(--res-gold); border-radius: 20px;
    padding: 0.15rem 0.6rem; font-weight: 700; text-transform: uppercase;
    letter-spacing: 0.06em; margin-left: 0.75rem;
  }

  /* Loader */
  .res-loader-overlay {
    position: fixed; inset: 0; background: rgba(107,30,46,0.12);
    z-index: 9999; display: flex; align-items: center; justify-content: center;
  }
  .res-loader-box {
    background: var(--res-white); border: 2px solid var(--res-gold);
    border-radius: var(--res-radius); padding: 1.5rem 2.5rem;
    display: flex; align-items: center; gap: 1rem;
    font-weight: 700; color: var(--res-burgundy); box-shadow: var(--res-shadow);
  }

  /* Capacity note */
  .cap-ok  { color: #155724; font-size: 0.78rem; font-weight: 700; }
  .cap-err { color: #721c24; font-size: 0.78rem; font-weight: 700; }

  /* Approver stage */
  .res-switch-row { display: flex; align-items: center; gap: 0.75rem; padding: 0.4rem 0; }
  .res-switch-label { font-size: 0.88rem; color: var(--res-text); }

  @media (max-width: 768px) {
    .res-header-banner { flex-direction: column; align-items: flex-start; gap: 0.5rem; }
    .res-step { font-size: 0.65rem; padding: 0.5rem 0.25rem; }
    .res-action-bar { justify-content: center; }
  }
`;

function injectStyles(id, css) {
    if (document.getElementById(id)) return;
    const el = document.createElement('style');
    el.id = id;
    el.textContent = css;
    document.head.appendChild(el);
}

// ────────────────────────────────────────────────────────────────────────────
class TableReservation extends Component {

    // ════════════════════════════════════════════════════════════════════════
    //  STATE — identical field structure to original. UI-only additions:
    //    uiStep, uiCalYear, uiCalMonth  (never sent to backend)
    // ════════════════════════════════════════════════════════════════════════
    state = {
        // ── backend / workflow state (UNCHANGED) ──────────────────────────
        type: 'add',
        loading: false,
        loadOnce: true,
        currentStage: 0,
        reqStatus: null,
        requestNum: null,
        DynamicRequestID: null,
        DynamicSupervisor: null,
        DynamicSupervisorsList: null,
        dynamicSupervisorDisplay: false,
        reqType: null,
        Delegate_WF_Level_ID: null,
        requestactionid: null,
        actionType: null,

        // ── stages (UNCHANGED — exact same structure as original) ─────────
        stages: [
            {
                AllowApprove: true,
                AllowAttachments: false,
                AllowForms: false,
                AllowActions: true,
                Description: 'Requester',
                stageFields: {
                    field_005001000001: {
                        FieldName: '005001000001', FieldLabel: 'Requested For',
                        FieldValue: this.props.loggedUserDetail.EmpID, FieldType: DROPDOWN_TYPE, DataType: 'string',
                        ParentFieldId: '000', ChildRowNmbr: 1, type: 'attributes',
                        FieldId: '2fa201b5-5ce7-4304-89be-89bc1afbebc3', ContainerFields: null,
                    },
                    field_005001000002: {
                        FieldName: '005001000002', FieldLabel: 'Request Date',
                        FieldValue: new Date(), FieldType: DATEPICKER, DataType: 'string',
                        ParentFieldId: '000', ChildRowNmbr: 1, type: 'attributes',
                        FieldId: 'c7bcc4ed-cd83-426a-b425-c2c38a5a98e2', ContainerFields: null,
                    },
                    field_005001000003: {
                        FieldName: '005001000003', FieldLabel: 'Date',
                        FieldValue: '', FieldType: DATEPICKER, DataType: 'string',
                        ParentFieldId: '000', ChildRowNmbr: 1, type: 'attributes',
                        FieldId: 'b8880871-ebba-4baa-a81d-c481782c6ed4', ContainerFields: null,
                    },
                    field_005001000004: {
                        FieldName: '005001000004', FieldLabel: 'Time',
                        FieldValue: '', FieldType: DATETIMEPICKER, DataType: 'string',
                        ParentFieldId: '000', ChildRowNmbr: 1, type: 'attributes',
                        FieldId: 'bfc2cb36-6070-4071-8db1-f640ba78763d', ContainerFields: null,
                    },
                    field_005001000005: {
                        FieldName: '005001000005', FieldLabel: 'Duration',
                        FieldValue: '', FieldType: INPUT, DataType: 'string',
                        ParentFieldId: '000', ChildRowNmbr: 1, type: 'attributes',
                        FieldId: '792bca55-2ba0-4387-82ab-601af5fe81a8', ContainerFields: null,
                    },
                    field_005001000006: {
                        FieldName: '005001000006', FieldLabel: 'Table',
                        FieldValue: null, FieldType: MULTIDROPDOWN, DataType: 'string',
                        ParentFieldId: '000', ChildRowNmbr: 1, type: 'attributes',
                        FieldId: 'e9bcbd59-8384-4843-9c26-74da4db65179', ContainerFields: null,
                    },
                    field_005001000007: {
                        FieldName: '005001000007', FieldLabel: 'Total Guest',
                        FieldValue: '', FieldType: INPUT, DataType: 'int',
                        ParentFieldId: '000', ChildRowNmbr: 1, type: 'attributes',
                        FieldId: 'ac0e8592-d048-4d2f-b4ac-df0f9094a502', ContainerFields: null,
                    },
                    field_005001000008: {
                        FieldName: '005001000008', FieldLabel: 'Adults',
                        FieldValue: '', FieldType: INPUT, DataType: 'int',
                        ParentFieldId: '000', ChildRowNmbr: 1, type: 'attributes',
                        FieldId: 'e98fc1b4-fbda-4a44-800a-764e49fff46a', ContainerFields: null,
                    },
                    field_005001000009: {
                        FieldName: '005001000009', FieldLabel: 'Child',
                        FieldValue: '', FieldType: INPUT, DataType: 'int',
                        ParentFieldId: '000', ChildRowNmbr: 1, type: 'attributes',
                        FieldId: '25d44de6-7345-48cc-bb3a-edaa43dc62b2', ContainerFields: null,
                    },
                    field_005001000010: {
                        FieldName: '005001000010', FieldLabel: 'Family',
                        FieldValue: false, FieldType: SWITCH, DataType: 'int',
                        ParentFieldId: '000', ChildRowNmbr: 1, type: 'attributes',
                        FieldId: 'da6d6d9a-61c1-4f30-9c6e-0830fe5b3ec0', ContainerFields: null,
                    },
                    field_005001000011: {
                        FieldName: '005001000011', FieldLabel: 'Customer Name',
                        FieldValue: '', FieldType: INPUT, DataType: 'string',
                        ParentFieldId: '000', ChildRowNmbr: 1, type: 'attributes',
                        FieldId: '3a48f399-bdfd-4e4b-9c0a-879aa08d62f2', ContainerFields: null,
                    },
                    field_005001000012: {
                        FieldName: '005001000012', FieldLabel: 'Mobile Number',
                        FieldValue: localStorage.getItem('mobile') || '', FieldType: INPUT, DataType: 'string',
                        ParentFieldId: '000', ChildRowNmbr: 1, type: 'attributes',
                        FieldId: '44bb6f5d-9991-48ce-9997-85c8942b48e0', ContainerFields: null,
                    },
                    field_005001000013: {
                        FieldName: '005001000013', FieldLabel: 'Email',
                        FieldValue: localStorage.getItem('email') || '', FieldType: INPUT, DataType: 'string',
                        ParentFieldId: '000', ChildRowNmbr: 1, type: 'attributes',
                        FieldId: '18699d99-cc8f-40eb-b45e-b8905a863a82', ContainerFields: null,
                    },
                    field_005001000014: {
                        FieldName: '005001000014', FieldLabel: 'Remarks',
                        FieldValue: '', FieldType: TEXTAREA, DataType: 'string',
                        ParentFieldId: '000', ChildRowNmbr: 1, type: 'attributes',
                        FieldId: 'e73f4648-db13-4895-94b7-e74a15645f2b', ContainerFields: null,
                    },
                },
            },
            {
                AllowApprove: false,
                AllowAttachments: false,
                AllowForms: false,
                AllowActions: false,
                Description: 'Approver',
                stageFields: {
                    field_005002000015: {
                        FieldName: '005002000015', FieldLabel: 'Remarks',
                        FieldValue: '', FieldType: TEXTAREA, DataType: 'string',
                        ParentFieldId: '000', ChildRowNmbr: 1, type: 'attributes',
                        FieldId: '2e9aca87-97e3-4904-8384-104bb8e22d85', ContainerFields: null,
                    },
                },
            },
        ],

        // ── UI-only state (NEVER included in payload) ─────────────────────
        uiStep: 0,                    // which wizard step is shown
        uiCalYear: new Date().getFullYear(),
        uiCalMonth: new Date().getMonth(),
        uiSelectedDate: null,         // JS Date object for calendar highlight
        uiSelectedTime: null,         // string e.g. "7:00 PM"
        uiSpecialTags: [],            // e.g. ['family','birthday']
    };

    // ════════════════════════════════════════════════════════════════════════
    //  LIFECYCLE — UNCHANGED
    // ════════════════════════════════════════════════════════════════════════
    componentDidMount() {
        injectStyles('res-theme-styles', STYLES);
        let type = this.props.match.params.type;
        var search = window.location.search;
        if (search === '') search = window.location.pathname;
        let params = new URLSearchParams(search);
        let sno = params.get('sno');
        let actionTypeP = params.get('type');
        let reqActionId = params.get('Actionid');
        let workflowID = params.get('levelid');
        const stageSequence = (this.props.location.state && this.props.location.state.stagesequence) || this.state.currentStage;
        this.setState({ currentStage: stageSequence });
        if (sno) { sno = DECRYPT(sno); this.setState({ currentStage: parseInt(sno) }); }
        if (actionTypeP) { actionTypeP = DECRYPT(actionTypeP); this.setState({ actionType: actionTypeP }); }
        if (reqActionId) { reqActionId = DECRYPT(reqActionId); this.setState({ requestactionid: reqActionId }); }
        if (workflowID) { workflowID = DECRYPT(workflowID); this.setState({ Delegate_WF_Level_ID: workflowID }); }
        this.props.getMasterKeywordList('Employee');
        // if (type !== 'add') {
        //     this.setState({ loading: true });
        //     setTimeout(() => { this.setState({ loading: false }); this.fetchSingleProcess(); }, 2000);
        // }
    }

    fetchSingleProcess = () => {
        let id = this.props.match.params.id;
        localStorage.removeItem('Employee/RequestAttributesDetails?Id=' + id);
        this.props.getMasterTableList('Employee/RequestAttributesDetails?Id=' + id);
    };

    // ── componentDidUpdate (UNCHANGED) ──────────────────────────────────────
    componentDidUpdate(prevProps) {
        if (this.props.tableLists.requestAttribute1 !== undefined && this.state.loadOnce) {
            let id = this.props.match.params.id;
            let type = this.props.match.params.type;
            if (!id) {
                let search = window.location.pathname;
                if (search.indexOf('/') !== -1) { id = search.split('/')[3]?.split('&')[0]; }
            }
            let data = this.props.tableLists;
            let reqStatus = data.status;
            let requestNum = data.requestNum;
            let stages = [];
            if (data.requestAttribute1 && data.requestAttribute1.length > 0) {
                stages = data.requestAttribute1.map((stageList, stageIndex) => {
                    let stageFields = stageList.stage_Field;
                    let stageFieldArray = [];
                    if (stageFields && stageFields.length > 0) {
                        stageFieldArray = stageFields.map((fields) => {
                            let fieldsY = 'field_' + fields.fieldName;
                            let fieldValue = fields.fieldValue;
                            if (fields.fieldType === 8 || fields.fieldType === '8') {
                                fieldValue = fieldValue ? new Date(fieldValue) : '';
                            } else if (fields.fieldType === 7 || fields.fieldType === '7') {
                                fieldValue = fieldValue ? new Date(fieldValue) : '';
                            } else if (fields.fieldType === 10 || fields.fieldType === '10') {
                                fieldValue = fields.fieldValue === 'true';
                            }
                            if (fields.fieldType === 3 || fields.fieldType === '3') {
                                if (typeof fieldValue === 'string' && fieldValue) {
                                    fieldValue = fieldValue.split(',');
                                } else { fieldValue = fieldValue || null; }
                            }
                            return {
                                [fieldsY]: {
                                    ChildRowNmbr: fields.childRowNmbr,
                                    DataType: fields.dataType,
                                    FieldLabel: fields.fieldDescription,
                                    FieldName: fields.fieldName,
                                    FieldType: fields.fieldType,
                                    FieldValue: fieldValue,
                                    ParentFieldId: fields.parentFieldId,
                                    stageNum: fields.stageNum,
                                    processNum: stageList.processNum,
                                    FieldSequence: fields.fieldSequence,
                                    IsActive: true,
                                    CompanyID: fields.companyId,
                                    StageSequence: stageList.stageSequence,
                                    type: fields.containerType || 'attributes',
                                    ContainerFields: null,
                                    FieldId: fields.fieldId,
                                },
                            };
                        });
                    }
                    let objStageArray = Object.assign({}, ...stageFieldArray);
                    return {
                        AllowApprove: true,
                        AllowAttachments: false,
                        AllowForms: false,
                        AllowActions: false,
                        Description: stageList.description,
                        stageFields: objStageArray,
                    };
                });
            }

            // Sync UI calendar/time from loaded field values
            const loadedDate = stages[0]?.stageFields?.field_005001000003?.FieldValue;
            const loadedTime = stages[0]?.stageFields?.field_005001000004?.FieldValue;
            const uiCalYear = loadedDate ? new Date(loadedDate).getFullYear() : this.state.uiCalYear;
            const uiCalMonth = loadedDate ? new Date(loadedDate).getMonth() : this.state.uiCalMonth;

            this.setState({
                type,
                stages: stages.length > 0 ? stages : this.state.stages,
                loadOnce: false,
                reqStatus,
                requestNum,
                uiSelectedDate: loadedDate || null,
                // Time field in edit mode is a Date object; extract display string
                uiSelectedTime: loadedTime
                    ? moment(loadedTime).format('h:mm A')
                    : null,
                uiCalYear,
                uiCalMonth,
            });
        }
    }

    componentWillUnmount() {
        const { clearCacheStorage } = this.props;
        if (clearCacheStorage) {
            clearCacheStorage('request', {
                containerData: {}, requestAttributeData: {},
                keywordValuesList: [], subordinatesListData: [],
            });
        }
    }

    // ════════════════════════════════════════════════════════════════════════
    //  updateChangeDetails — UNCHANGED (this is the ONLY way fields are set)
    // ════════════════════════════════════════════════════════════════════════
    updateChangeDetails = (e, Index, FieldLabel, FieldType, DataType, ParentFieldId, ChildRowNmbr) => {
        let dateFormat = this.props.userPref?.dateFormat;
        let { name, value } = e.target;
        if (FieldType === 'calendar') { value = DateFormetter(value, dateFormat); }

        let copyStages = [...this.state.stages];
        let indexStage = copyStages[Index];
        let stageField = indexStage.stageFields;

        // Auto-compute Total Guest (UNCHANGED)
        if (name === 'field_005001000008' || name === 'field_005001000009') {
            const adults = name === 'field_005001000008'
                ? parseInt(value) || 0
                : parseInt(stageField['field_005001000008']?.FieldValue) || 0;
            const child = name === 'field_005001000009'
                ? parseInt(value) || 0
                : parseInt(stageField['field_005001000009']?.FieldValue) || 0;
            const total = adults + child;
            let fid7 = stageField['field_005001000007']?.FieldId || '';
            stageField['field_005001000007'] = {
                ...stageField['field_005001000007'],
                FieldName: '005001000007',
                FieldValue: total > 0 ? String(total) : '',
            };
            if (fid7) stageField['field_005001000007'].FieldId = fid7;
        }

        let FieldId = stageField[name]?.FieldId || '';
        stageField[name] = {
            FieldName: removeString(name),
            FieldLabel,
            FieldValue: value,
            FieldType,
            DataType,
            ParentFieldId,
            ChildRowNmbr,
            type: stageField[name]?.type || 'attributes',
            ContainerFields: stageField[name]?.ContainerFields || null,
        };
        if (FieldId) stageField[name].FieldId = FieldId;

        indexStage.stageFields = stageField;
        copyStages[Index] = indexStage;
        this.setState({ stages: copyStages });
    };

    // ════════════════════════════════════════════════════════════════════════
    //  saveRequest — UNCHANGED
    // ════════════════════════════════════════════════════════════════════════
    saveRequest = (type, redirect = '') => {
        this.setState({ loading: true, reqType: null });
        let groupAttributes = [];
        let fieldSequence = 1;
        var RequestedFor = '';
        var Remarks = '';
        var RequestedDate = new Date();
        var FromDate = new Date();
        var ToDate = new Date();
        var err = false;
        let id = this.props.tableLists?.requestID;

        if (this.state.stages && this.state.stages.length > 0) {
            this.state.stages.forEach((stageList, stageIndex) => {
                let stageFields = stageList.stageFields;
                let stageNumber = parseInt('001') + stageIndex;
                let StageSequence = stageIndex;

                Object.entries(stageFields).forEach(([key, field]) => {
                    if (field.FieldName === '005001000001') RequestedFor = field.FieldValue;
                    if (field.FieldName === '005001000002') RequestedDate = field.FieldValue;
                    if (field.FieldName === '005001000003') FromDate = field.FieldValue;
                    if (field.FieldName === '005001000014') Remarks = field.FieldValue;

                    if (stageIndex === 0 && type !== 'actionSubmit') {
                        const required = [
                             '005001000003', '005001000004',
                            '005001000006', '005001000007', '005001000011', '005001000012',
                        ];
                        if (required.includes(field.FieldName)) {
                            const val = field.FieldValue;
                            const empty = val === null || val === '' || val === undefined
                                || (Array.isArray(val) && val.length === 0);
                            if (empty) {
                                this.growl.show({ severity: 'error', summary: null, detail: field.FieldLabel + ' is required' });
                                err = true;
                            }
                        }
                    }
                    if (err) { this.setState({ loading: false }); return; }

                    let serialisedValue = field.FieldValue;
                    if (field.FieldType === MULTIDROPDOWN || field.FieldType === '3') {
                        serialisedValue = Array.isArray(field.FieldValue)
                            ? field.FieldValue.join(',')
                            : (field.FieldValue || '');
                    } else if (
                        field.FieldType === DATEPICKER || field.FieldType === '8' ||
                        field.FieldType === DATETIMEPICKER || field.FieldType === '7'
                    ) {
                        serialisedValue = moment(field.FieldValue).format('MM/DD/YYYY');
                    }

                    let val = {
                        ChildRowNmbr: field.ChildRowNmbr,
                        DataType: field.DataType,
                        FieldDescription: field.FieldLabel,
                        FieldName: field.FieldName,
                        FieldType: field.FieldType,
                        FieldValue: serialisedValue,
                        ParentFieldId: field.ParentFieldId,
                        stageNum: stageNumber,
                        processNum: '005',
                        FieldSequence: fieldSequence++,
                        IsActive: true,
                        CompanyID: this.props.loggedUserDetail.CompanyId,
                        StageSequence: StageSequence,
                        ContainerType: field.type,
                    };
                    if (this.state.type === 'edit' && field.FieldId && field.FieldId !== '') {
                        val.FieldId = field.FieldId;
                    }
                    groupAttributes.push(val);
                });
            });
        }

        if (err) return;

        let data = {
            FromDate: moment(FromDate).format('MM/DD/YYYY'),
            ToDate: moment(ToDate).format('MM/DD/YYYY'),
            VisaCount: 0,
            TicketCount: 0,
            RequestDesc: 'Table Reservation',
            IsActive: true,
            RequestDate: RequestedDate,
            LoginEmployeeID: this.props.loggedUserDetail.empID,
            CompanyID: this.props.loggedUserDetail.CompanyId,
            Remark: Remarks,
            RequestedFor: this.props.loggedUserDetail.empID,
            // BranchID: this.props.loggedUserDetail.BranchID,
            RequestType: null,
            ProcessID: TABLE_RESERVATION_PROCESS_ID,
            RequestAttributes: groupAttributes,
            Requestattachments: [],
            Requestforms: [],
            Requestactions: [],
            StageSequence: this.state.currentStage,
        };

        if (this.state.type === 'add') {
            data.EmpID = this.props.loggedUserDetail.empID;
            if (this.state.DynamicRequestID !== null) data.RequestID = this.state.DynamicRequestID;
        }
        if (this.state.type === 'edit') { data.RequestID = id; }
        if (this.state.DynamicSupervisor !== null) { data.DynamicSupervisor = this.state.DynamicSupervisor; }
        if (type === 'delegate' && this.state.Delegate_WF_Level_ID !== null) { data.Delegate_WF_Level_ID = this.state.Delegate_WF_Level_ID; }
        if (type === 'return' && this.state.Delegate_WF_Level_ID !== null) { data.Return_WF_Level_ID = this.state.Delegate_WF_Level_ID; }

        let model = 'requestSave';
        if (type === 'submit') model = 'TableReservation';

        let url = this.state.type === 'edit'
            ? '/master/api/UpdateDynamicData?model=' + model
            : '/master/api/InsertDynamicData?model=' + model;
        if (type === 'submit') url = '/master/api/workflow/submit?type=' + model;
        if (type === 'reject') url = '/master/api/workflow/Reject?type=TableReservation';
        if (type === 'cancel') url = '/master/api/workflow/Cancel?type=TableReservation';
        if (type === 'delegate') url = '/master/api/workflow/delegate?type=TableReservation';
        if (type === 'return') url = '/master/api/workflow/return?type=TableReservation';

        const dd = JSON.stringify(data);
        const datas = { Key: dd };

        axios.post(url, JSON.stringify(datas))
            .then(response => {
                this.setState({ loading: false });
                if (['submit', 'cancel', 'reject', 'delegate', 'return'].includes(type)) {
                    if (response.status === 200) {
                        if (response.data.id !== undefined && response.data.id === 'DYNAMIC') {
                            let submitValue = JSON.parse(response.data.result);
                            let tableValue = [];
                            if (submitValue.Table?.length > 0) {
                                tableValue = submitValue.Table.map(list => ({
                                    label: list.NAME,
                                    value: list.EMPLOYEE_ID,
                                    id: list.EMPLOYEE_NO,
                                    Request_WF_LEVEL_ID: list.Request_WF_LEVEL_ID,
                                }));
                            }
                            this.setState({
                                dynamicSupervisorDisplay: true,
                                DynamicSupervisorsList: tableValue,
                                DynamicRequestID: response.data.requestId,
                            });
                        } else {
                            localStorage.removeItem(`Request/GetRequest?id=${this.props.loggedUserDetail.empID}&processid=${TABLE_RESERVATION_PROCESS_ID}`);
                            this.growl.show({ severity: 'success', summary: null, detail: 'Request Submitted Successfully' });
                            setTimeout(() => { this.props.history.push(redirect || '/table-reservation-list'); }, 2000);
                        }
                    } else {
                        this.growl.show({ severity: 'error', summary: null, detail: 'Submission Failed' });
                    }
                } else {
                    if (response.data.statusCode === 1) {
                        localStorage.removeItem(`Request/GetRequest?id=${this.props.loggedUserDetail.empID}&processid=${TABLE_RESERVATION_PROCESS_ID}`);
                        this.growl.show({ severity: 'success', summary: null, detail: response.data.message });
                        setTimeout(() => { this.props.history.push('/table-reservation-list'); }, 2000);
                    } else {
                        this.growl.show({ severity: 'error', summary: null, detail: 'Save Failed' });
                    }
                }
            })
            .catch(err => {
                this.setState({ loading: false });
                this.growl.show({ severity: 'error', summary: null, detail: (err?.response?.data) || 'Request Failed' });
            });
    };

    // ════════════════════════════════════════════════════════════════════════
    //  UI HELPERS — call updateChangeDetails to keep payload in sync
    // ════════════════════════════════════════════════════════════════════════

    // ── Calendar navigation ──────────────────────────────────────────────────
    prevMonth = () => {
        let { uiCalYear, uiCalMonth } = this.state;
        if (uiCalMonth === 0) { uiCalMonth = 11; uiCalYear--; } else { uiCalMonth--; }
        this.setState({ uiCalYear, uiCalMonth });
    };
    nextMonth = () => {
        let { uiCalYear, uiCalMonth } = this.state;
        if (uiCalMonth === 11) { uiCalMonth = 0; uiCalYear++; } else { uiCalMonth++; }
        this.setState({ uiCalYear, uiCalMonth });
    };

    // ── Pick a calendar day → sets field_005001000003 (Date) via updateChangeDetails ──
    pickDay = (day) => {
        const { uiCalYear, uiCalMonth } = this.state;
        const selectedDate = new Date(uiCalYear, uiCalMonth, day);
        this.setState({ uiSelectedDate: selectedDate, uiSelectedTime: null });

        // Clear the Time field when date changes
        this.updateChangeDetails(
            { target: { name: 'field_005001000004', value: '' } },
            0, 'Time', DATETIMEPICKER, 'string', '000', 1
        );

        // Set the Date field (field_005001000003)
        this.updateChangeDetails(
            { target: { name: 'field_005001000003', value: selectedDate } },
            0, 'Date', DATEPICKER, 'string', '000', 1
        );
    };

    // ── Pick a time slot → sets field_005001000004 (Time) via updateChangeDetails ──
    // Time is stored as a Date object (same as original DATETIMEPICKER handling).
    // We combine the selected calendar date + selected time string into one Date.
    pickTime = (timeStr) => {
        const { uiSelectedDate } = this.state;
        if (!uiSelectedDate) return;

        // Parse "7:00 PM" into hours/minutes
        const [timePart, meridiem] = timeStr.split(' ');
        let [hours, minutes] = timePart.split(':').map(Number);
        if (meridiem === 'PM' && hours !== 12) hours += 12;
        if (meridiem === 'AM' && hours === 12) hours = 0;

        const dateTimeValue = new Date(uiSelectedDate);
        dateTimeValue.setHours(hours, minutes, 0, 0);

        this.setState({ uiSelectedTime: timeStr });

        // Set Time field (field_005001000004)
        this.updateChangeDetails(
            { target: { name: 'field_005001000004', value: dateTimeValue } },
            0, 'Time', DATETIMEPICKER, 'string', '000', 1
        );
    };

    // ── Toggle a table tile → sets field_005001000006 (MultiSelect) via updateChangeDetails ──
    toggleTable = (tableValue) => {
        const currentVal = this.state.stages[0].stageFields['field_005001000006']?.FieldValue;
        let arr = Array.isArray(currentVal) ? [...currentVal] : [];
        const idx = arr.indexOf(tableValue);
        if (idx > -1) arr.splice(idx, 1); else arr.push(tableValue);

        this.updateChangeDetails(
            { target: { name: 'field_005001000006', value: arr.length ? arr : null } },
            0, 'Table', MULTIDROPDOWN, 'string', '000', 1
        );
    };

    // ── Stepper for Adults / Children → updateChangeDetails (unchanged logic) ──
    adjustGuests = (fieldKey, fieldLabel, delta) => {
        const current = parseInt(this.state.stages[0].stageFields[fieldKey]?.FieldValue) || 0;
        const min = fieldKey === 'field_005001000008' ? 1 : 0;
        const next = Math.max(min, current + delta);
        const fieldName = fieldKey === 'field_005001000008' ? '005001000008' : '005001000009';
        this.updateChangeDetails(
            { target: { name: fieldKey, value: String(next) } },
            0, fieldLabel, INPUT, 'int', '000', 1
        );
    };

    // ── Special tag toggle → sets field_005001000010 (Family switch) ──
    toggleSpecialTag = (tag) => {
        const tags = [...this.state.uiSpecialTags];
        const idx = tags.indexOf(tag);
        if (idx > -1) tags.splice(idx, 1); else tags.push(tag);
        this.setState({ uiSpecialTags: tags });

        // Sync Family switch field
        if (tag === 'family') {
            const newVal = !this.state.stages[0].stageFields['field_005001000010']?.FieldValue;
            this.updateChangeDetails(
                { target: { name: 'field_005001000010', value: newVal } },
                0, 'Family', SWITCH, 'int', '000', 1
            );
        }
    };

    // ── Wizard step navigation ───────────────────────────────────────────────
    goStep = (n) => this.setState({ uiStep: n });

    // ── Dropdown options (UNCHANGED) ─────────────────────────────────────────
    getDropdownOptions = (fieldName) => {
        switch (fieldName) {
            case '005001000001': return this.getRequesterOptions();
            case '005001000006': return TABLE_OPTIONS;
            default: return [];
        }
    };
    getRequesterOptions = () => {
        const hrTeam = parseInt(localStorage.getItem('hrTeam'));
        const { loggedUserDetail, Employee = [], subordinatesListData = [] } = this.props;
        if (hrTeam) {
            return Employee.reduce((acc, el) => {
                if (el.value !== loggedUserDetail?.empID) acc.push(el);
                else acc.push({ ...el, label: 'Self' });
                return acc;
            }, []);
        }
        const selfOption = loggedUserDetail
            ? [{ label: `${loggedUserDetail.userName} (Self)`, value: loggedUserDetail.empID }]
            : [];
        return selfOption.concat(subordinatesListData || []);
    };

    isRequired = (fieldName) =>
        ['005001000001', '005001000003', '005001000004',
            '005001000006', '005001000007', '005001000011', '005001000012'].includes(fieldName);

    // ── Render the original PrimeReact fields (used for Approver stage & edit mode fallback) ──
    renderField = (field, key, index, readonly) => {
        const ft = parseInt(field.FieldType);
        const commonProps = {
            name: key,
            onChange: e => this.updateChangeDetails(
                e, index, field.FieldLabel, field.FieldType,
                field.DataType, field.ParentFieldId, field.ChildRowNmbr
            ),
        };
        switch (ft) {
            case INPUT:
                return <InputText className="p-col-12" value={field.FieldValue || ''} placeholder={field.FieldLabel} readOnly={readonly} {...commonProps} />;
            case DROPDOWN_TYPE:
                return <Dropdown placeholder={'Select ' + field.FieldLabel} options={this.getDropdownOptions(field.FieldName)} value={field.FieldValue} style={{ width: '100%' }} disabled={readonly} {...commonProps} {...DROPDOWN_CONFIG} />;
            case MULTIDROPDOWN:
                return <MultiSelect placeholder={'Select ' + field.FieldLabel} options={this.getDropdownOptions(field.FieldName)} value={field.FieldValue} style={{ width: '100%' }} disabled={readonly} display="chip" {...commonProps} />;
            case TEXTAREA:
                return <InputTextarea rows={3} cols={30} className="width100" placeholder={field.FieldLabel} value={field.FieldValue || ''} readOnly={readonly} autoResize={true} {...commonProps} />;
            case DATEPICKER:
                return <Calendar placeholder={field.FieldLabel} value={field.FieldValue || ''} disabled={readonly} style={{ width: '100%' }} {...commonProps} {...CALENDAR_CONFIG} />;
            case DATETIMEPICKER:
                return <Calendar placeholder={field.FieldLabel} value={field.FieldValue || ''} showTime hourFormat="12" disabled={readonly} style={{ width: '100%' }} {...commonProps} {...CALENDAR_CONFIG} />;
            case SWITCH:
                return (
                    <div className="res-switch-row">
                        <InputSwitch name={key} checked={field.FieldValue === true} disabled={readonly}
                            onChange={e => this.updateChangeDetails(e, index, field.FieldLabel, field.FieldType, field.DataType, field.ParentFieldId, field.ChildRowNmbr)} />
                        <span className="res-switch-label">{field.FieldValue === true ? 'Yes' : 'No'}</span>
                    </div>
                );
            default:
                return <InputText className="p-col-12" value={field.FieldValue || ''} placeholder={field.FieldLabel} readOnly={readonly} {...commonProps} />;
        }
    };

    // ════════════════════════════════════════════════════════════════════════
    //  CALENDAR RENDER
    // ════════════════════════════════════════════════════════════════════════
    renderCalendar = () => {
        const { uiCalYear, uiCalMonth, uiSelectedDate } = this.state;
        const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const DAYS = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
        const today = new Date();
        const firstDay = new Date(uiCalYear, uiCalMonth, 1).getDay();
        const daysInM = new Date(uiCalYear, uiCalMonth + 1, 0).getDate();

        return (
            <>
                <div className="res-cal-header">
                    <button className="res-cal-nav" onClick={this.prevMonth}><i className="pi pi-chevron-left" /></button>
                    <span className="res-cal-month">{MONTHS[uiCalMonth]} {uiCalYear}</span>
                    <button className="res-cal-nav" onClick={this.nextMonth}><i className="pi pi-chevron-right" /></button>
                </div>
                <div className="res-cal-grid">
                    {DAYS.map(d => <div key={d} className="res-cal-dayname">{d}</div>)}
                    {Array.from({ length: firstDay }).map((_, i) => <div key={'e' + i} className="res-cal-day empty" />)}
                    {Array.from({ length: daysInM }).map((_, i) => {
                        const day = i + 1;
                        const dateObj = new Date(uiCalYear, uiCalMonth, day);
                        const isPast = dateObj < new Date(today.getFullYear(), today.getMonth(), today.getDate());
                        const isToday = today.getFullYear() === uiCalYear && today.getMonth() === uiCalMonth && today.getDate() === day;
                        const isSel = uiSelectedDate
                            && new Date(uiSelectedDate).getFullYear() === uiCalYear
                            && new Date(uiSelectedDate).getMonth() === uiCalMonth
                            && new Date(uiSelectedDate).getDate() === day;
                        let cls = 'res-cal-day';
                        if (isPast) cls += ' unavail';
                        if (isToday) cls += ' today';
                        if (isSel) cls += ' selected';
                        return (
                            <div key={day} className={cls} onClick={!isPast ? () => this.pickDay(day) : undefined}>
                                {day}
                            </div>
                        );
                    })}
                </div>
            </>
        );
    };

    // ════════════════════════════════════════════════════════════════════════
    //  TIME SLOTS RENDER
    // ════════════════════════════════════════════════════════════════════════
    renderTimeSlots = () => {
        const { uiSelectedTime } = this.state;
        return (
            <div className="res-time-grid">
                {TIME_SLOTS.map(t => {
                    const isSel = uiSelectedTime === t;
                    return (
                        <div key={t} className={`res-time-slot${isSel ? ' selected' : ''}`} onClick={() => this.pickTime(t)}>
                            {t}
                            <span className="res-slot-sub">Available</span>
                        </div>
                    );
                })}
            </div>
        );
    };

    // ════════════════════════════════════════════════════════════════════════
    //  TABLE TILES RENDER
    // ════════════════════════════════════════════════════════════════════════
    renderTableTiles = () => {
        const currentVal = this.state.stages[0].stageFields['field_005001000006']?.FieldValue;
        const selected = Array.isArray(currentVal) ? currentVal : [];

        return (
            <div className="res-table-grid">
                {TABLE_OPTIONS.map(t => {
                    const isSel = selected.includes(t.value);
                    const isTaken = false; // replace with real availability check if needed
                    const tagCls = isTaken ? 'tag-taken' : t.private ? 'tag-private' : 'tag-avail';
                    const tagLbl = isTaken ? 'Taken' : t.private ? 'Private' : 'Available';
                    return (
                        <div
                            key={t.value}
                            className={`res-table-tile${isTaken ? ' tile-taken' : ''}${isSel ? ' selected' : ''}`}
                            onClick={!isTaken ? () => this.toggleTable(t.value) : undefined}
                        >
                            <i className={`pi ${t.icon} res-tile-icon`} />
                            <i className="pi pi-check res-tile-check" />
                            <div className="res-tile-name">{t.label.split(' (')[0]}</div>
                            <div className="res-tile-cap">{t.cap} seats</div>
                            <span className={`res-tile-tag ${tagCls}`}>{tagLbl}</span>
                        </div>
                    );
                })}
            </div>
        );
    };

    // ════════════════════════════════════════════════════════════════════════
    //  RESERVATION SUMMARY (step 4 sidebar)
    // ════════════════════════════════════════════════════════════════════════
    renderSummary = () => {
        const s0 = this.state.stages[0]?.stageFields || {};
        const dateVal = s0['field_005001000003']?.FieldValue;
        const timeVal = s0['field_005001000004']?.FieldValue;
        const tables = s0['field_005001000006']?.FieldValue;
        const total = s0['field_005001000007']?.FieldValue;
        const adults = s0['field_005001000008']?.FieldValue;
        const children = s0['field_005001000009']?.FieldValue;
        return (
            <div className="res-summary-card">
                <div className="res-summary-header">Reservation summary</div>
                <div className="res-summary-body">
                    <div className="res-sum-row">
                        <span className="res-sum-lbl">Date</span>
                        <span className="res-sum-val">{dateVal ? moment(dateVal).format('MMM D, YYYY') : '—'}</span>
                    </div>
                    <div className="res-sum-row">
                        <span className="res-sum-lbl">Time</span>
                        <span className="res-sum-val">{this.state.uiSelectedTime || '—'}</span>
                    </div>
                    <div className="res-sum-row">
                        <span className="res-sum-lbl">Tables</span>
                        <span className="res-sum-val">{Array.isArray(tables) && tables.length ? tables.join(', ') : '—'}</span>
                    </div>
                    <div className="res-sum-row">
                        <span className="res-sum-lbl">Guests</span>
                        <span className="res-sum-val">
                            {total ? `${total} total` : '—'}
                            {adults ? ` (${adults} adults` : ''}
                            {children ? `, ${children} children)` : adults ? ')' : ''}
                        </span>
                    </div>
                </div>
            </div>
        );
    };

    // ════════════════════════════════════════════════════════════════════════
    //  MAIN RENDER
    // ════════════════════════════════════════════════════════════════════════
    render() {
        const {
            loading, stages, currentStage, reqStatus, requestNum,
            type, uiStep, uiSelectedDate, uiSelectedTime, uiSpecialTags,
        } = this.state;
        const { loading: propsLoading, error, success, userPosInfo } = this.props;

        const s0 = stages[0]?.stageFields || {};
        const s1 = stages[1]?.stageFields || {};
        const s0Readonly = currentStage !== 0;
        const s1Readonly = currentStage !== 1;

        const adults = parseInt(s0['field_005001000008']?.FieldValue) || 0;
        const children = parseInt(s0['field_005001000009']?.FieldValue) || 0;
        const total = adults + children;

        const selectedTables = Array.isArray(s0['field_005001000006']?.FieldValue)
            ? s0['field_005001000006'].FieldValue : [];
        const tableCap = selectedTables.reduce((sum, id) => {
            const t = TABLE_OPTIONS.find(x => x.value === id);
            return sum + (t ? t.cap : 0);
        }, 0);

        // Determine edit-mode status (UNCHANGED logic)
        let edstatus = 'open';
        if (currentStage !== 0) {
            const { location = {} } = this.props;
            const { state = {} } = location?.state || {};
            edstatus = state?.editStatus;
        }

        // Step bar labels
        const STEPS = ['Date & time', 'Tables', 'Guests', 'Contact'];

        // ── Requester dropdown (compact, always visible at top of add form) ──
        const requesterField = s0['field_005001000001'];

        return (
            <div className="res-page p-grid">

                {/* ── Loader ── */}
                {(loading || propsLoading) && (
                    <div className="res-loader-overlay">
                        <div className="res-loader-box">
                            <i className="pi pi-spin pi-spinner" style={{ fontSize: '1.5rem' }} />
                            Please wait…
                        </div>
                    </div>
                )}

                {/* ── Toast + messages ── */}
                <Toast ref={el => (this.growl = el)} />
                {error && <div className="p-col-12"><Messages type="error" message={error} /></div>}
                {success && <div className="p-col-12"><Messages type="success" message={success} /></div>}

                {/* ── Header banner ── */}
                <div className="p-col-12" style={{ padding: 0 }}>
                    <div className="res-header-banner">
                        <div>
                            <h1 className="res-header-title">🍽 Table Reservation</h1>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                            {requestNum && (
                                <span className="res-chip">#{requestNum}</span>
                            )}
                        </div>
                    </div>
                </div>

                {/* ════════════════════════════════════════════════════════════
                    APPROVER VIEW (currentStage >= 1) — keep original card layout
                ════════════════════════════════════════════════════════════ */}
                {type === 'edit' && currentStage >= 1 && (
                    <>
                        {/* Stage 0 summary (readonly) */}
                        <div className="p-col-12">
                            <div className="res-card res-readonly-card">
                                <div className="res-card-header">
                                    <i className="pi pi-calendar res-card-icon" />
                                    <h2>Reservation Details <span className="res-readonly-badge"><i className="pi pi-lock" /> Read-only</span></h2>
                                </div>
                                <div className="res-card-body">
                                    <div className="p-grid">
                                        {['field_005001000001', 'field_005001000002', 'field_005001000003', 'field_005001000004',
                                            'field_005001000005', 'field_005001000006', 'field_005001000007', 'field_005001000008',
                                            'field_005001000009', 'field_005001000010', 'field_005001000011', 'field_005001000012',
                                            'field_005001000013'].map(key => {
                                                const field = s0[key]; if (!field) return null;
                                                return (
                                                    <div key={key} className="p-col-12 p-md-6 p-lg-4">
                                                        <div className="res-field">
                                                            <label className="res-label">{field.FieldLabel}</label>
                                                            {this.renderField(field, key, 0, true)}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Stage 1 — Approver Remarks */}
                        <div className="p-col-12">
                            <div className={`res-card${s1Readonly ? ' res-readonly-card' : ''}`}>
                                <div className="res-card-header">
                                    <i className="pi pi-check-circle res-card-icon" />
                                    <h2>{stages[1]?.Description || 'Approver'}</h2>
                                </div>
                                <div className="res-card-body">
                                    {s1['field_005002000015'] && (
                                        <div className="res-field">
                                            <label className="res-label">Remarks</label>
                                            {this.renderField(s1['field_005002000015'], 'field_005002000015', 1, s1Readonly)}
                                        </div>
                                    )}
                                </div>
                                <div className="res-action-bar">
                                    <Button className="res-btn-gold" label="Approve" icon="pi pi-check" disabled={edstatus === 'Closed'} onClick={() => this.saveRequest('submit', '/dashboard')} />
                                    <Button className="res-btn-danger" label="Reject" icon="pi pi-times" disabled={edstatus === 'Closed'} onClick={() => this.saveRequest('reject', '/dashboard')} />
                                    <Button className="res-btn-warning" label="Return" icon="pi pi-replay" disabled={edstatus === 'Closed'} onClick={() => this.saveRequest('return', '/dashboard')} />
                                    <Link to="/dashboard"><Button className="res-btn-secondary" label="Back" icon="pi pi-arrow-left" /></Link>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {/* ════════════════════════════════════════════════════════════
                    REQUESTER VIEW (currentStage === 0) — new calendar/tile UI
                ════════════════════════════════════════════════════════════ */}
                {(type === 'add' || (type === 'edit' && currentStage === 0)) && stages.length > 0 && (
                    <div className="p-col-12">
                        <div className="res-card">

                            {/* ── "Requested For" stays at top — compact dropdown ── */}
                            {/* {requesterField && (
                                <div className="res-card-body" style={{ borderBottom: '1px solid var(--res-border)', paddingBottom: '1rem' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                                        <label className="res-label" style={{ margin: 0, whiteSpace: 'nowrap' }}>
                                            Requested For <span className="res-required">*</span>
                                        </label>
                                        <div style={{ flex: '1', minWidth: '200px', maxWidth: '320px' }}>
                                            {this.renderField(requesterField, 'field_005001000001', 0, s0Readonly)}
                                        </div>
                                    
                                    </div>
                                </div>
                            )} */}

                            {/* ── Step bar ── */}
                            <div className="res-card-body" style={{ paddingBottom: 0 }}>
                                <div className="res-step-bar">
                                    {STEPS.map((label, i) => {
                                        let cls = 'res-step';
                                        if (i === uiStep) cls += ' active';
                                        else if (i < uiStep) cls += ' done';
                                        return (
                                            <div key={i} className={cls} onClick={() => this.goStep(i)}>
                                                <span className="res-step-num">{i + 1}</span>
                                                {label}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            {/* ════════════════════════════════════════════════
                                STEP 0 — DATE & TIME
                            ════════════════════════════════════════════════ */}
                            <div className={`res-panel${uiStep === 0 ? ' active' : ''}`}>
                                <div className="res-card-body">
                                    <div className="p-grid">
                                        {/* Calendar */}
                                        <div className="p-col-12 p-md-6">
                                            <div className="res-section-head">
                                                <i className="pi pi-calendar" /> Pick a date
                                            </div>
                                            {this.renderCalendar()}
                                        </div>

                                        {/* Time slots — show only after a date is picked */}
                                        <div className="p-col-12 p-md-6">
                                            {uiSelectedDate ? (
                                                <>
                                                    <div className="res-section-head">
                                                        <i className="pi pi-clock" /> Pick a time
                                                    </div>
                                                    {this.renderTimeSlots()}

                                                    {/* Duration field (sits naturally here) */}
                                                    {s0['field_005001000005'] && (
                                                        <div className="res-field" style={{ marginTop: '1.25rem' }}>
                                                            <label className="res-label">Duration</label>
                                                            {this.renderField(s0['field_005001000005'], 'field_005001000005', 0, s0Readonly)}
                                                        </div>
                                                    )}
                                                </>
                                            ) : (
                                                <div style={{ color: 'var(--res-text-muted)', fontSize: '0.85rem', paddingTop: '2rem', textAlign: 'center' }}>
                                                    <i className="pi pi-arrow-left" style={{ marginRight: '0.4rem' }} />
                                                    Select a date first
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="res-action-bar">
                                    {uiSelectedDate && (
                                        <span className="res-chip" style={{ marginRight: '0.25rem' }}>
                                            <i className="pi pi-calendar" /> {moment(uiSelectedDate).format('MMM D, YYYY')}
                                        </span>
                                    )}
                                    {uiSelectedTime && (
                                        <span className="res-chip">
                                            <i className="pi pi-clock" /> {uiSelectedTime}
                                        </span>
                                    )}
                                    <div className="res-ml-auto">
                                        <Button
                                            className="res-btn-primary"
                                            label="Next: Tables"
                                            icon="pi pi-arrow-right"
                                            iconPos="right"
                                            disabled={!uiSelectedDate || !uiSelectedTime}
                                            onClick={() => this.goStep(1)}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* ════════════════════════════════════════════════
                                STEP 1 — TABLE TILES
                            ════════════════════════════════════════════════ */}
                            <div className={`res-panel${uiStep === 1 ? ' active' : ''}`}>
                                <div className="res-card-body">
                                    <div className="res-section-head">
                                        <i className="pi pi-th-large" /> Select one or more tables
                                    </div>
                                    {this.renderTableTiles()}
                                </div>
                                <div className="res-action-bar">
                                    <Button className="res-btn-secondary" label="Back" icon="pi pi-arrow-left" onClick={() => this.goStep(0)} />
                                    {selectedTables.length > 0 && (
                                        <span className="res-chip">
                                            {selectedTables.join(', ')} selected
                                        </span>
                                    )}
                                    <div className="res-ml-auto">
                                        <Button
                                            className="res-btn-primary"
                                            label="Next: Guests"
                                            icon="pi pi-arrow-right"
                                            iconPos="right"
                                            disabled={selectedTables.length === 0}
                                            onClick={() => this.goStep(2)}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* ════════════════════════════════════════════════
                                STEP 2 — GUESTS
                            ════════════════════════════════════════════════ */}
                            <div className={`res-panel${uiStep === 2 ? ' active' : ''}`}>
                                <div className="res-card-body">
                                    <div className="res-section-head"><i className="pi pi-users" /> Guest count</div>
                                    <div className="res-guest-rows">
                                        {/* Adults */}
                                        <div className="res-guest-row">
                                            <div>
                                                <div className="res-guest-label">Adults</div>
                                                <div className="res-guest-sub">Age 13+</div>
                                            </div>
                                            <div className="res-stepper">
                                                <button className="res-step-btn" onClick={() => this.adjustGuests('field_005001000008', 'Adults', -1)}>−</button>
                                                <div className="res-step-val">{adults || 1}</div>
                                                <button className="res-step-btn" onClick={() => this.adjustGuests('field_005001000008', 'Adults', 1)}>+</button>
                                            </div>
                                        </div>
                                        {/* Children */}
                                        <div className="res-guest-row">
                                            <div>
                                                <div className="res-guest-label">Children</div>
                                                <div className="res-guest-sub">Age under 13</div>
                                            </div>
                                            <div className="res-stepper">
                                                <button className="res-step-btn" onClick={() => this.adjustGuests('field_005001000009', 'Child', -1)}>−</button>
                                                <div className="res-step-val">{children}</div>
                                                <button className="res-step-btn" onClick={() => this.adjustGuests('field_005001000009', 'Child', 1)}>+</button>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Total + capacity check */}
                                    <div className="res-total-bar">
                                        <div>
                                            <div className="res-total-lbl">Total guests</div>
                                            <div className="res-total-num">{total > 0 ? total : (adults || 1)}</div>
                                        </div>
                                        {tableCap > 0 && (
                                            <span className={total <= tableCap ? 'cap-ok' : 'cap-err'}>
                                                <i className={`pi ${total <= tableCap ? 'pi-check-circle' : 'pi-exclamation-circle'}`} />{' '}
                                                {total <= tableCap ? `Fits (${tableCap} seat cap)` : `Exceeds cap (${tableCap} seats)`}
                                            </span>
                                        )}
                                    </div>

                                    {/* Special request tags — syncs Family field */}
                                    <div style={{ marginTop: '1.25rem' }}>
                                        <div className="res-section-head"><i className="pi pi-tag" /> Special requests</div>
                                        <div className="res-tag-toggles">
                                            {[
                                                { key: 'family', label: 'Family section' },
                                                { key: 'birthday', label: 'Birthday' },
                                                { key: 'anniversary', label: 'Anniversary' },
                                                { key: 'vip', label: 'VIP setup' },
                                                { key: 'vegetarian', label: 'Vegetarian menu' },
                                            ].map(tag => (
                                                <div
                                                    key={tag.key}
                                                    className={`res-tag-toggle${uiSpecialTags.includes(tag.key) ? ' on' : ''}`}
                                                    onClick={() => this.toggleSpecialTag(tag.key)}
                                                >
                                                    {tag.label}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="res-action-bar">
                                    <Button className="res-btn-secondary" label="Back" icon="pi pi-arrow-left" onClick={() => this.goStep(1)} />
                                    <div className="res-ml-auto">
                                        <Button
                                            className="res-btn-primary"
                                            label="Next: Contact"
                                            icon="pi pi-arrow-right"
                                            iconPos="right"
                                            onClick={() => this.goStep(3)}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* ════════════════════════════════════════════════
                                STEP 3 — CONTACT + SUMMARY
                            ════════════════════════════════════════════════ */}
                            <div className={`res-panel${uiStep === 3 ? ' active' : ''}`}>
                                <div className="res-card-body">
                                    <div className="p-grid">
                                        {/* Contact fields */}
                                        <div className="p-col-12 p-md-8">
                                            <div className="res-section-head"><i className="pi pi-phone" /> Contact details</div>
                                            {/* Customer Name */}
                                            <div className="res-field">
                                                <label className="res-label">Customer Name <span className="res-required">*</span></label>
                                                {this.renderField(s0['field_005001000011'], 'field_005001000011', 0, s0Readonly)}
                                            </div>
                                            <div className="p-grid">
                                                <div className="p-col-12 p-md-6">
                                                    <div className="res-field">
                                                        <label className="res-label">Mobile <span className="res-required">*</span></label>
                                                        {this.renderField(s0['field_005001000012'], 'field_005001000012', 0, s0Readonly)}
                                                    </div>
                                                </div>
                                                <div className="p-col-12 p-md-6">
                                                    <div className="res-field">
                                                        <label className="res-label">Email</label>
                                                        {this.renderField(s0['field_005001000013'], 'field_005001000013', 0, s0Readonly)}
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Remarks */}
                                            {s0['field_005001000014'] && (
                                                <div className="res-field">
                                                    <label className="res-label">Notes / Remarks</label>
                                                    {this.renderField(s0['field_005001000014'], 'field_005001000014', 0, s0Readonly)}
                                                </div>
                                            )}
                                        </div>

                                        {/* Summary sidebar */}
                                        <div className="p-col-12 p-md-4">
                                            {this.renderSummary()}
                                        </div>
                                    </div>
                                </div>

                                {/* Action bar */}
                                <div className="res-action-bar">
                                    <Button className="res-btn-secondary" label="Back" icon="pi pi-arrow-left" onClick={() => this.goStep(2)} />
                                    {(reqStatus === null || reqStatus === 'RETURNED TO REQUESTER') && (
                                        <>
                                            <Button
                                                className="res-btn-secondary"
                                                label="Save Draft"
                                                icon="pi pi-save"
                                                onClick={() => this.saveRequest('save')}
                                            />
                                            <div className="res-ml-auto">
                                                <Button
                                                    className="res-btn-primary"
                                                    label="Confirm Reservation"
                                                    icon="pi pi-send"
                                                    onClick={() => this.saveRequest('submit')}
                                                />
                                            </div>
                                        </>
                                    )}
                                    <Link to="/table-reservation-list">
                                        <Button className="res-btn-secondary" label="Cancel" icon="pi pi-times" />
                                    </Link>
                                </div>
                            </div>

                        </div>{/* /res-card */}
                    </div>
                )}

            </div>
        );
    }
}

// ─── Redux wiring (UNCHANGED) ────────────────────────────────────────────────
const mapStateToProps = state => ({
    state,
    error: state.master.error,
    loading: state.master.loading,
    success: state.master.success,
    loggedUserDetail: state.auth.userObject,
    userPosInfo: state.auth.userPosInfo,
    userPref: state.auth.userPref,
    Employee: state.keyword.Employee || [],
    tableLists: state.master.tableLists,
    subordinatesListData: state.master.subordinatesListData,
});

const mapDispatchToProps = dispatch => ({
    getMasterKeywordList: value => dispatch(actions.getMasterKeywordList(value)),
    getMasterTableList: table => dispatch(actions.getMasterTableList(table)),
    clearCacheStorage: (t, d) => dispatch(actions.clearCacheStorage(t, d)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TableReservation);